import { css as g, LitElement as u, html as d } from "lit";
import { property as a, customElement as p } from "lit/decorators.js";
import { classMap as m } from "lit/directives/class-map.js";
import { b as v } from "./styles-scZ6dVz-.js";
var b = Object.defineProperty, h = Object.getOwnPropertyDescriptor, e = (t, l, n, i) => {
  for (var o = i > 1 ? void 0 : i ? h(l, n) : l, s = t.length - 1, c; s >= 0; s--)
    (c = t[s]) && (o = (i ? c(l, n, o) : c(o)) || o);
  return i && o && b(l, n, o), o;
};
let r = class extends u {
  constructor() {
    super(...arguments), this.variant = "primary", this.size = "md", this.dot = !1, this.pill = !1, this.outline = !1;
  }
  render() {
    const t = {
      badge: !0,
      [this.variant]: !0,
      [this.size]: !0,
      dot: this.dot,
      pill: this.pill,
      outline: this.outline
    };
    return d`
      <span part="badge" class=${m(t)}>
        ${this.dot ? "" : d`<slot></slot>`}
      </span>
    `;
  }
};
r.styles = [
  v,
  g`
      :host {
        display: inline-flex;
      }

      .badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-weight: var(--r5-font-medium);
        border-radius: var(--r5-radius-full);
        white-space: nowrap;
        line-height: 1;
      }

      /* Sizes */
      .sm {
        height: 1.25rem;
        min-width: 1.25rem;
        padding: 0 var(--r5-space-1-5);
        font-size: 0.625rem;
      }

      .md {
        height: 1.5rem;
        min-width: 1.5rem;
        padding: 0 var(--r5-space-2);
        font-size: var(--r5-text-xs);
      }

      .lg {
        height: 1.75rem;
        min-width: 1.75rem;
        padding: 0 var(--r5-space-2-5);
        font-size: var(--r5-text-sm);
      }

      /* Variants */
      .primary {
        background-color: var(--r5-badge-bg, var(--r5-color-primary-100));
        color: var(--r5-badge-color, var(--r5-color-primary-700));
      }

      .secondary {
        background-color: var(--r5-badge-bg, var(--r5-color-neutral-100));
        color: var(--r5-badge-color, var(--r5-color-neutral-700));
      }

      .success {
        background-color: var(--r5-badge-bg, var(--r5-color-success-100));
        color: var(--r5-badge-color, var(--r5-color-success-700));
      }

      .warning {
        background-color: var(--r5-badge-bg, var(--r5-color-warning-100));
        color: var(--r5-badge-color, var(--r5-color-warning-700));
      }

      .danger {
        background-color: var(--r5-badge-bg, var(--r5-color-danger-100));
        color: var(--r5-badge-color, var(--r5-color-danger-700));
      }

      .info {
        background-color: var(--r5-badge-bg, var(--r5-color-info-100));
        color: var(--r5-badge-color, var(--r5-color-info-700));
      }

      /* Dot mode (no text, just indicator) */
      .dot {
        padding: 0;
        border-radius: var(--r5-radius-full);
      }

      .dot.sm {
        width: 0.5rem;
        height: 0.5rem;
        min-width: unset;
      }

      .dot.md {
        width: 0.625rem;
        height: 0.625rem;
        min-width: unset;
      }

      .dot.lg {
        width: 0.75rem;
        height: 0.75rem;
        min-width: unset;
      }

      .dot.primary {
        background-color: var(--r5-color-primary-500);
      }

      .dot.secondary {
        background-color: var(--r5-color-neutral-500);
      }

      .dot.success {
        background-color: var(--r5-color-success-500);
      }

      .dot.warning {
        background-color: var(--r5-color-warning-500);
      }

      .dot.danger {
        background-color: var(--r5-color-danger-500);
      }

      .dot.info {
        background-color: var(--r5-color-info-500);
      }

      /* Pill mode (less rounded) */
      .pill {
        border-radius: var(--r5-radius-md);
      }

      /* Outline mode */
      .outline {
        background-color: transparent;
        border: 1px solid currentColor;
      }
    `
];
e([
  a({ type: String, reflect: !0 })
], r.prototype, "variant", 2);
e([
  a({ type: String, reflect: !0 })
], r.prototype, "size", 2);
e([
  a({ type: Boolean, reflect: !0 })
], r.prototype, "dot", 2);
e([
  a({ type: Boolean, reflect: !0 })
], r.prototype, "pill", 2);
e([
  a({ type: Boolean, reflect: !0 })
], r.prototype, "outline", 2);
r = e([
  p("ark-badge")
], r);
export {
  r as A
};
//# sourceMappingURL=ark-badge-Cjppwi53.js.map
